<div>
    <i class="{{icon}}"></i>
    <h2>{{text}}</h2>
</div>